import { GzSandboxEndpointSensorWebComponent } from './component/GzSandboxEndpointSensorWebComponent';

export { GzSandboxEndpointSensorWebComponent };
